/**
 * Sessione kiosk hardcoded per il monitor di magazzino (account Screen,
 * ac_user_type_cod = 3).
 *
 * Il token è STATICO lato backend: non scade e non viene mai ruotato.
 * Serve a garantire che il monitor (schermo 24/7 non presidiato su
 * /warehouseorders) non risulti MAI scollegato: se la sessione in
 * localStorage sparisce (update dell'app, blackout, storage azzerato),
 * ScreenTokenGuard e AuthInterceptor la ricostruiscono da qui senza
 * intervento umano.
 *
 * ATTENZIONE: questo token finisce nel bundle JS ed è quindi estraibile
 * da chiunque apra i dev tools. È accettabile solo finché il backend
 * limita i permessi dell'account Screen. Stesso valore su tutti gli
 * ambienti (localhost / dev / production) per decisione concordata.
 */
export const SCREEN_KIOSK_SESSION = {
  email: 'warehouse@livith.it',
  // account_id reale dell'account (visto in localStorage dopo un login
  // vero) — da non confondere con ac_user_type_cod = 3 (tipo Screen).
  accountId: 4057,
  token:
    'Nd4EMDiIo9+30cx5kb92qNu325+fPzVRybXw5ZUDM/r99/rpAo4kFe3W3RQTISUCebNPHWjkZgYpMVWoSAl6XtZnxp9zMUHM42FUKIqhWYqVYSVYg8yNVMsvoSGeY5FElYOmYTQSvC11WoYuNo5z+2h/xPYFKCw7/G7VU6XVYI=',
} as const;
